import { useState, useEffect, useCallback } from 'react';
import api from 'services/api';

export default function PaieSocialePage() {
  const [data, setData] = useState({ config: null, agents: [], totaux: { masse_salariale: 0, cnss_salarie: 0, cnss_employeur: 0, total_charges: 0, cout_total: 0 } });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try { const r = await api.get('/comptabilite/paie-sociale'); setData(r.data); } catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const t = data.totaux;
  const cfg = data.config || { abreviation: 'CNSS', taux_salarial: 4, taux_patronal: 16.5, actif: true };
  const lblSal = `${cfg.abreviation} salarie (${cfg.actif ? cfg.taux_salarial + '%' : 'suspendu'})`;
  const lblPat = `${cfg.abreviation} employeur (${cfg.actif ? cfg.taux_patronal + '%' : 'suspendu'})`;

  return (
    <div>
      {!cfg.actif && (
        <div style={{ padding: 12, background: '#FFF7ED', border: '1px solid #FB923C', borderRadius: 8, marginBottom: 16, fontSize: 13, color: '#9A3412', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 18 }}>&#9888;</span>
          <span><strong>Declarations suspendues</strong> — {cfg.mention_suspension || 'Charges sociales : en cours de regularisation'}</span>
        </div>
      )}
      {/* ⚠️ PERIMETRE DECLARE — mesure conservatoire du 01/09/2026. Cet etat
          ne lit QUE les agents : il exclut structurellement le personnel
          administratif. Le chiffre reste incomplet, il CESSE de se faire
          passer pour complet. */}
      <div style={{ fontSize: 12, color: '#92400E', background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 6, padding: '8px 12px', marginBottom: 12 }}>
        Périmètre : agents de sécurité uniquement. Le personnel administratif n'est pas inclus dans cette déclaration.
      </div>


      <div className="stats-grid">
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">Masse salariale</span></div><div className="stat-card-value">{t.masse_salariale.toLocaleString()}</div><div className="stat-card-sub">FCFA/mois</div></div>
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">{lblPat}</span></div><div className="stat-card-value" style={{ color: cfg.actif ? '#f57c00' : '#999' }}>{t.cnss_employeur.toLocaleString()}</div><div className="stat-card-sub">FCFA</div></div>
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">{lblSal}</span></div><div className="stat-card-value" style={{ color: cfg.actif ? undefined : '#999' }}>{t.cnss_salarie.toLocaleString()}</div><div className="stat-card-sub">FCFA</div></div>
        <div className="stat-card"><div className="stat-card-header"><span className="stat-card-label">Cout total employeur</span></div><div className="stat-card-value" style={{ color: '#DC2626' }}>{t.cout_total.toLocaleString()}</div><div className="stat-card-sub">FCFA</div></div>
      </div>

      <div className="content-card">
        <div className="gss-toolbar">
          <div className="content-card-title">Paie & Charges sociales — {data.agents.length} agents actifs</div>
        </div>
        {loading ? <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p> : (
          <div className="gss-table-wrap">
            <table className="gss-table">
              <thead><tr><th>Matricule</th><th>Nom</th><th>Poste</th><th>Salaire base</th><th>{lblSal}</th><th>{lblPat}</th><th>Net a payer</th></tr></thead>
              <tbody>
                {data.agents.map(a => {
                  const base = Number(a.salaire_base) || 0;
                  const cnss_s = Number(a.cnss_salarie) || 0;
                  const cnss_e = Number(a.cnss_employeur) || 0;
                  const net = base - cnss_s;
                  return (
                    <tr key={a.id}>
                      <td style={{ fontSize: '0.8rem', color: '#888' }}>{a.matricule}</td>
                      <td style={{ fontWeight: 600 }}>{a.prenom} {a.nom}</td>
                      <td>{a.poste || '-'}</td>
                      <td style={{ textAlign: 'right' }}>{base.toLocaleString()}</td>
                      <td style={{ textAlign: 'right', color: cfg.actif ? '#f57c00' : '#999' }}>{cnss_s.toLocaleString()}</td>
                      <td style={{ textAlign: 'right', color: cfg.actif ? '#DC2626' : '#999' }}>{cnss_e.toLocaleString()}</td>
                      <td style={{ textAlign: 'right', fontWeight: 700 }}>{net.toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ fontWeight: 700, borderTop: '2px solid #8B1A1A' }}>
                  <td colSpan={3}>TOTAL</td>
                  <td style={{ textAlign: 'right' }}>{t.masse_salariale.toLocaleString()}</td>
                  <td style={{ textAlign: 'right', color: cfg.actif ? '#f57c00' : '#999' }}>{t.cnss_salarie.toLocaleString()}</td>
                  <td style={{ textAlign: 'right', color: cfg.actif ? '#DC2626' : '#999' }}>{t.cnss_employeur.toLocaleString()}</td>
                  <td style={{ textAlign: 'right' }}>{(t.masse_salariale - t.cnss_salarie).toLocaleString()}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
        <div style={{ padding: '1rem', fontSize: 11, color: cfg.actif ? '#888' : '#9A3412', fontStyle: 'italic' }}>
          {cfg.actif
            ? `Calcul ${cfg.abreviation} — Part salariale ${cfg.taux_salarial}% + Part patronale ${cfg.taux_patronal}%`
            : cfg.mention_suspension || 'Charges sociales : en cours de regularisation'
          }
        </div>
      </div>
    </div>
  );
}
